package com.zi.support.shared

/**
 * The Insights Week / Month / Year periods run from the start of the current calendar week (Monday), month (the 1st)
 * or year (1 January) up to today, not a rolling 7, 30 or 365 days. Web, Android and iOS count "days back from today",
 * so this gives how many days back that first day is, from today's local date.
 */
object InsightPeriod {
    fun firstDaysBack(kind: String, year: Int, month: Int, day: Int): Int = when (kind) {
        "week" -> (daysFromCivil(year, month, day) + 3).mod(7)  // 1970-01-01 was a Thursday; Monday is 0
        "month" -> day - 1
        "year" -> (daysFromCivil(year, month, day) - daysFromCivil(year, 1, 1)).toInt()
        else -> 0
    }.toInt()

    fun label(kind: String): String = when (kind) { "week" -> "This week"; "month" -> "This month"; "year" -> "This year"; else -> "Today" }

    /** Days since 1970-01-01 (Howard Hinnant's days_from_civil). */
    private fun daysFromCivil(y0: Int, m: Int, d: Int): Long {
        val y = if (m <= 2) y0 - 1 else y0
        val era = y.floorDiv(400)
        val yoe = y - era * 400
        val doy = (153 * (if (m > 2) m - 3 else m + 9) + 2) / 5 + d - 1
        return era * 146_097L + yoe * 365 + yoe / 4 - yoe / 100 + doy - 719_468
    }
}
